<ng-container *ngIf="worker">
    <c-card *transloco="let t">
      <c-card-body class="container-sm px-2">
              <c-row>
                <c-col md="12" lg="6">
                    <h3>{{ t('Messages for') }} {{worker.name}}</h3>
                </c-col>
                <c-col md="12" lg="6" class="text-end mb-2">

                    <button color="light" cButton routerLink="/home">
                        <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                        {{ t('Return to Home') }}
                    </button>


                </c-col>
              </c-row>

              <p>{{ t('Here are all the messages we have for:',{name: worker.name}) }} </p>

              <c-row *ngIf="worker.messages">
                <c-col>
                        <ng-container *ngFor="let message of worker.messages">
                                <span *ngIf="message.type=='message'"><i class="fa-regular fa-comment"></i> {{message.information}}</span>
                                <span *ngIf="message.type=='voice_message'"><i class="fa-solid fa-voicemail"></i> {{ t('Voice Message:') }} <a href="{{message.information}}" target="_new">{{ t('Listen Now') }}</a></span>
                                <span class="fw-light"> {{ t('at') }} {{message.time}}</span><br/>
                                <hr/>
                        </ng-container>
                </c-col>
              </c-row>

      </c-card-body>
    </c-card>

    </ng-container>
